export default __webpack_public_path__ + "static/benifitImage3-25b29dd0c93ce7dbbf1d43af809dfa5f.png";